module.exports = __webpack_public_path__ + "static/media/Rainfall_Hurt.4fb21c23.gif";